<template>
  <RoleGate minLevel="supervisor" :showWhenDenied="true">
    <div class="settings-form">
      <div class="form-grid">
        <!-- Usuário Porto -->
        <div class="form-group">
          <label>Usuário Portal Porto</label>
          <div class="input-wrapper" :class="{ 'error-state': errors.user }">
            <i class="bi bi-person-fill-lock text-primary icon"></i>
            <input 
              v-if="companyData && companyData.userPorto" 
              type="text" 
              class="form-control"
              v-model="companyData.userPorto.user" 
              placeholder="Ex: porto_admin" 
            />
          </div>
          <span v-if="errors.user" class="error-message"><i class="bi bi-exclamation-circle"></i> {{ errors.user }}</span>
        </div>

        <!-- Senha Porto -->
        <div class="form-group">
          <label>Senha de Acesso</label>
          <div class="input-wrapper">
            <i class="bi bi-shield-lock-fill text-warning icon"></i>
            <input 
              v-if="companyData && companyData.userPorto" 
              :type="showPassword ? 'text' : 'password'"
              class="form-control" 
              v-model="companyData.userPorto.password" 
              placeholder="Digite a senha"
              id="senha" 
            />
            <button type="button" class="btn-toggle-password" @click="showPassword = !showPassword">
               <i :class="showPassword ? 'bi bi-eye-slash-fill' : 'bi bi-eye-fill'"></i>
            </button>
          </div>
        </div>
      </div>
      
      <div class="form-actions mt-4">
        <BotaoSalvarComponent @click="postForm" />
      </div>
    </div>
  </RoleGate>
</template>

<script setup>
import axios from '@/axios.js';
import BotaoSalvarComponent from './ui/BotaoSalvar.vue';
import { showToast } from '@/eventBus.js';
import { ref } from 'vue';
import RoleGate from './RoleGate.vue';

const errors = ref({});
const showPassword = ref(false);

const props = defineProps({
    companyData: { type: Object, required: true },
});

function postForm() {
    axios.put(`/api/company/edit`, props.companyData)
        .then(response => {
            Object.assign(props.companyData, response.data.data);
            errors.value = {};
            showToast(response.data.message);
        }).catch(error => {
            if(error?.response?.data?.errors) {
                errors.value = error.response.data.errors;
            }
            showToast(error?.response?.data?.message || "Erro ao salvar os dados.");
        });
};
</script>

<style scoped>
/* Copied standardized V2 form layouts */
.settings-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-group label {
  font-weight: 600;
  color: #475569;
  font-size: 0.9rem;
}

.input-wrapper {
  display: flex;
  align-items: center;
  background-color: #F8FAFC;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  padding: 0.5rem 1rem;
  transition: all 0.2s ease;
}

.input-wrapper:focus-within {
  border-color: #DF523A;
  box-shadow: 0 0 0 3px rgba(223, 82, 58, 0.1);
  background-color: #FFFFFF;
}

.input-wrapper.error-state {
  border-color: #EF4444;
  background-color: #FEF2F2;
}

.error-message {
  color: #EF4444;
  font-size: 0.8rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  margin-top: 0.25rem;
}

.input-wrapper .icon {
  font-size: 1.15rem;
  color: #94A3B8;
  margin-right: 0.75rem;
}

.text-primary { color: #3B82F6 !important; }
.text-warning { color: #F59E0B !important; }

.form-control {
  flex: 1;
  background: transparent;
  border: none;
  color: #1E293B;
  font-size: 0.95rem;
  font-family: inherit;
  font-weight: 500;
  padding: 0.25rem 0;
  outline: none;
}

.form-control::placeholder {
  color: #CBD5E1;
  font-weight: 400;
}

.btn-toggle-password {
  background: transparent;
  border: none;
  color: #94A3B8;
  font-size: 1.25rem;
  padding: 0.25rem;
  cursor: pointer;
  transition: color 0.2s;
}

.btn-toggle-password:hover {
  color: #DF523A;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
}

@media (max-width: 767.98px) {
  .form-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
}
</style>